import { createAxiosInstance } from "./axios-instance";

export const axios = createAxiosInstance();

export default axios;
